import { env } from '@/env'
import { api } from '@/services/fintalk/api'
import { HttpError } from '@/services/fintalk/api/types/errors/HttpError'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

export type UploadEntityType = 'company' | 'project' | 'bot' | 'user'

export interface CreateCompanyUploadParams {
  companyId: string
  mimeType: string
  entityType: UploadEntityType
}

export interface CreateCompanyUploadResponse {
  key: string
  pre_signed_url: string
}

export async function createCompanyUpload({
  companyId,
  mimeType,
  entityType,
}: CreateCompanyUploadParams): Promise<CreateCompanyUploadResponse> {
  const resp = await api.post<CreateCompanyUploadResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/company/${companyId}/upload`,
    {
      body: {
        mimetype: mimeType,
        entity_type: entityType,
      },
    },
  )

  return resp.body
}

export async function uploadCompanyFile(
  preSignedUrl: string,
  file: File,
): Promise<void> {
  let res: Response

  try {
    res = await fetch(preSignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    })
  } catch (error) {
    throw new NetworkError(`Failed to fetch PUT ${preSignedUrl}`, {
      cause: error,
    })
  }

  if (!res.ok) {
    throw new HttpError(`PUT ${preSignedUrl} [${res.status}]`, {
      response: {
        body: await res.text(),
        statusCode: res.status,
        statusText: res.statusText,
        headers: res.headers,
      },
    })
  }
}
